import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";

const JoinUs = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-16">
        <div className="flex items-center justify-center flex-col max-w-[871px] mx-auto">
          <BlueHeading text="Join Us" />
          <Heading
            children="Join Us in This Revolutionary Journey"
            className="text-center"
          />
          <p className="lg:text-[26px] sm:text-xl  text-lg font-normal leading-[150%] text-[#5E5C5C] text-center pt-4">
            We invite you to be part of this incredible journey towards a
            healthier, more sustainable future. Whether you are looking to
            enhance your wellness, improve your hydration, or join a global
            movement, Makeway India and Jeena Sikho are here to help you live
            your best life.
          </p>
        </div>
      </div>
      <div className="h-[250px]"></div>
    </>
  );
};

export default JoinUs;
